<template>
  <AdminLayout><PaidOrdersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import PaidOrdersTable from './PaidOrdersTable.vue';

export default {
  name: 'PaidOrders',
  components: { AdminLayout, PaidOrdersTable },
};
</script>
